import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import PriceLine, { TYPES } from '@conversion/components/PriceLine';

import Price from './components/Price';
import messages from './messages';

function CartPrice({ subtotal, intl }) {
  const { formatMessage } = intl;
  return (
    <Price>
      <PriceLine
        text={formatMessage(messages.subtotal)}
        price={subtotal}
        type={TYPES.SUB_TOTAL}
      />
    </Price>
  );
}

CartPrice.propTypes = {
  subtotal: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
};

export { CartPrice as CartPriceTest };
export default React.memo(injectIntl(CartPrice));
